import ParametrizadorE02 from './ParametrizadorE02/index'

export default {
  parametrizadorE02: ParametrizadorE02
}
